/* ============================================================
   Generated diamond artwork.
   Draws a faceted gem as inline SVG from a shape key and a hex
   colour, so every shape x colour pairing exists without any
   image upload. Ported from the reference prototype.
   ============================================================ */
(function () {
  'use strict';

  var ring = function (n, fn) {
    var out = [];
    for (var i = 0; i < n; i++) out.push(fn((i / n) * 2 * Math.PI));
    return out;
  };

  var oct = function (w, h, c) {
    return [
      [-w + c, -h], [w - c, -h], [w, -h + c], [w, h - c],
      [w - c, h], [-w + c, h], [-w, h - c], [-w, -h + c]
    ];
  };

  var SHAPES = {
    round: {
      label: 'Round',
      pts: ring(20, function (t) { return [Math.sin(t), -Math.cos(t)]; })
    },
    oval: {
      label: 'Oval',
      pts: ring(20, function (t) { return [0.76 * Math.sin(t), -Math.cos(t)]; })
    },
    pear: {
      label: 'Pear',
      c: [0, 0.18],
      pts: ring(22, function (t) {
        return [Math.sin(t) * Math.sin(t / 2) * 1.05, -Math.cos(t)];
      })
    },
    emerald: { label: 'Emerald', pts: oct(0.72, 1, 0.3) },
    princess: {
      label: 'Princess',
      pts: [[-0.85, -0.85], [0.85, -0.85], [0.85, 0.85], [-0.85, 0.85]]
    },
    radiant: { label: 'Radiant', pts: oct(0.8, 1, 0.2) },
    cushion: {
      label: 'Cushion',
      pts: ring(16, function (t) {
        var s = Math.sin(t), c = Math.cos(t), p = 3.2;
        var r = Math.pow(Math.pow(Math.abs(s), p) + Math.pow(Math.abs(c), p), -1 / p);
        return [0.92 * s * r, -0.92 * c * r];
      })
    },
    heart: {
      label: 'Heart',
      c: [0, -0.05],
      pts: ring(24, function (t) {
        return [
          (16 * Math.pow(Math.sin(t), 3)) / 17,
          -(13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t)) / 17
        ];
      })
    }
  };

  /* A theme-editor colour is a hex; the gem needs an HSL base. Very light or
     very dark picks are pulled into a band that still shows facet contrast. */
  function hexToHsl(hex) {
    var v = String(hex || '').trim().replace('#', '');
    if (v.length === 3) v = v[0] + v[0] + v[1] + v[1] + v[2] + v[2];
    if (!/^[0-9a-fA-F]{6}$/.test(v)) return [214, 42, 74];

    var r = parseInt(v.slice(0, 2), 16) / 255;
    var g = parseInt(v.slice(2, 4), 16) / 255;
    var b = parseInt(v.slice(4, 6), 16) / 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var l = (max + min) / 2, h = 0, s = 0;

    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
      else if (max === g) h = (b - r) / d + 2;
      else h = (r - g) / d + 4;
      h /= 6;
    }

    return [
      Math.round(h * 360),
      Math.min(95, Math.round(s * 100)),
      Math.min(78, Math.max(22, Math.round(l * 100)))
    ];
  }

  function svg(shapeKey, hex, label, cls) {
    var S = SHAPES[shapeKey] || SHAPES.round;
    var H = hexToHsl(hex);
    var O = S.pts;
    var c = S.c || [0, 0];
    var n = O.length;

    var sc = function (p, k) {
      return [c[0] + (p[0] - c[0]) * k, c[1] + (p[1] - c[1]) * k];
    };
    var T = O.map(function (p) { return sc(p, 0.55); });
    var P = O.map(function (p, i) {
      var q = O[(i + 1) % n];
      return sc([(p[0] + q[0]) / 2, (p[1] + q[1]) / 2], 0.8);
    });

    var pt = function (p) { return p[0].toFixed(3) + ',' + p[1].toFixed(3); };
    var fill = function (l) {
      return 'hsl(' + H[0] + ' ' + H[1] + '% ' + Math.max(7, Math.min(97, l)) + '%)';
    };
    var ang = function (pts) {
      var mx = pts.reduce(function (s, p) { return s + p[0]; }, 0) / pts.length;
      var my = pts.reduce(function (s, p) { return s + p[1]; }, 0) / pts.length;
      return Math.atan2(my - c[1], mx - c[0]);
    };
    var facet = function (pts, off, i, amp) {
      var l = H[2] + off + amp * Math.cos(ang(pts) - Math.PI * 1.25) + (i % 2 ? 5 : -5);
      return '<polygon points="' + pts.map(pt).join(' ') + '" fill="' + fill(l) + '"/>';
    };

    var out = '';
    for (var i = 0; i < n; i++) {
      var j = (i + 1) % n;
      var k = (i + n - 1) % n;
      out += facet([O[i], O[j], P[i]], 4, i, 16);
      out += facet([O[i], P[k], T[i], P[i]], -6, i, 18);
      out += facet([T[i], T[j], P[i]], 9, i, 14);
    }
    out += '<polygon points="' + T.map(pt).join(' ') + '" fill="' + fill(H[2] + 19) + '"/>';

    return (
      '<svg class="' + (cls || '') + '" viewBox="-1.25 -1.25 2.5 2.5" role="img" aria-label="' +
      String(label || '').replace(/"/g, '&quot;') +
      '"><g stroke="#fff" stroke-opacity=".7" stroke-width=".012" stroke-linejoin="round">' +
      out +
      '</g></svg>'
    );
  }

  window.PJGem = { SHAPES: SHAPES, svg: svg, hexToHsl: hexToHsl };
})();
